import { render, staticRenderFns } from "./Parcerias.vue?vue&type=template&id=e0a92908&scoped=true"
import script from "./Parcerias.vue?vue&type=script&lang=js"
export * from "./Parcerias.vue?vue&type=script&lang=js"
import style0 from "./Parcerias.vue?vue&type=style&index=0&id=e0a92908&prod&scoped=true&lang=css"
import style1 from "./Parcerias.vue?vue&type=style&index=1&id=e0a92908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a92908",
  null
  
)

export default component.exports